<template>
  <div>
    <div
      :id="`header_${index}`"
      v-for="(section, index) in sectionsStore"
      :key="section.id + '_' + index"
    >
      <template v-for="(block, blockIndex) in section.blocks">
        <section-header :type="section.type">
          <template slot="body">
            <slot name="block">
              
              <block
                :data="block.settings.fields[0]"
                :id="block.id"
                :css="block.settings.style"
                :blockIndex="blockIndex"
                :sectionId="section.id"
                :settings="block.settings"
                :uiBlockComponent="block.settings.component"
                :sectionTextColor="block.titleColor"
                :theme="theme"
              >
              </block>
              
            </slot>
          </template>
        </section-header>
      </template>
    </div>
  </div>
</template>
<script>
  import * as blocks from '@fremcast/section/blocks';
  import Grid from '@fremcast/section/Grid';
  
  const VIDEO_TYPE = 1;
  const PRESENTATION = "videoPresentation";
  export default {
    extends: Grid,
    data() {
      return {
        component: this.theme,
        sections: [],
        displaySectionTitle: true,
        blockList: blocks.default.data
      };
    },
    computed: {
      sectionsStore() {
        return this.options.length > 0 ? this.options : this.$store.getters['section/section'].header;
      }
    },
    props: {
      theme: String,
      options: {
        type: Array,
        default() {
          return [];
        }
      },
      slug: {
        type: String,
        default: ''
      }
    },
    components: {
      Block: () => import('@fremcast/section/Block')
    }
  }
</script>